import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class NumberOfEmployees extends KYCQuestion
{
	state = {
		fields: {
			radio_company_employees: {
				options: [
					{
						name: "radio_company_employees",
						label: "0",
						value: "0",
						checked: false
					},
					{
						name: "radio_company_employees",
						label: "1-9",
						value: "1-9",
						checked: false
					},
					{
						name: "radio_company_employees",
						label: "10-50",
						value: "10-50",
						checked: false
					},
					{
						name: "radio_company_employees",
						label: "51-99",
						value: "51-99",
						checked: false
					},
					{
						name: "radio_company_employees",
						label: "Över 100",
						value: ">100",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "radio_company_employees";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="radio"
					name="radio_company_employees"
					description="Hur många anställda har företaget?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.radio_company_employees.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/NumberOfEmployees.js